<template>
  <div class="slide-content" :class="{'is-visible': visible}">
    <div class="slide-content__hd">
      <el-button type="text" @click="handleClose"><i class="el-icon-close"></i></el-button>
    </div>
    <div class="slide-content__bd">
      <slot v-if="visible"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSlideBox',
  props: {
    name: String,
    visible: Boolean
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>


<style lang="scss">
.slide-content {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: calc( 100vh - 66px );
  position: fixed;
  top: 66px;
  right: 0;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
  background: #fff;
  z-index: 999;
  transform: translateX(100vw);
  transition: .3s ease-in-out transform;

  &.is-visible {
    transform: translateX(0)
  }

  .slide-content__hd {
    border-bottom: 1px solid #ddd;
    padding: 5px 15px;
  }
  .slide-content__bd {
    flex-grow: 1;
    padding: 10px 30px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// TheSlideBox.vue?360bc1ab